const i = () => {
  const o = localStorage.getItem("config.post_login_redirect_uri") || window.location.origin, t = localStorage.getItem("config.post_logout_redirect_uri") || window.location.origin;
  return {
    postLoginRedirectUri: o,
    postLogoutRedirectUri: t
  };
};
export {
  i as getConfigurations
};
